import { Drawer, Link } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React, { useEffect, useState } from 'react';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useExperienceContext, useOrderDetailsContext, usePTCDocumentsContext, } from '../../../hooks/useContexts';
import { PTCDocumentDrawerHeader } from './PTCDocumentDrawerHeader';
import { PTCDocumentDrawerBody } from './PTCDocumentDrawerBody';
import { PTCDocumentDrawerFooter } from './PTCDocumentDrawerFooter';
import { GetBectranDocumentsAPI } from '../../../api/oms/order-details';
import { FeatureSwitches } from '../../../constants/feature-switches';
export var PTCDocumentsLink = function () {
    var svocID = useThdCustomer().svocID;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var orderDetailsData = useOrderDetailsContext().orderDetailsData;
    var _a = usePTCDocumentsContext(), openPTCDocumentDrawer = _a.openPTCDocumentDrawer, setOpenPTCDocumentDrawer = _a.setOpenPTCDocumentDrawer, handleCloseDrawer = _a.handleCloseDrawer;
    // React States
    var _b = useState(undefined), bectranInvoicesData = _b[0], setBectranInvoicesData = _b[1];
    var _c = useState(undefined), bectranInvoicesError = _c[0], setBectranInvoicesError = _c[1];
    var _d = useState(false), bectranInvoicesLoaded = _d[0], setBectranInvoicesLoaded = _d[1];
    // Constants
    var _e = orderDetailsData || {}, purchaserId = _e.purchaserId, orderNumbers = _e.orderNumbers, orderNumber = _e.orderNumber, tenders = _e.tenders;
    var ptcInvoicesRequest = {
        invoiceRequest: {
            customerAccountId: svocID,
            purchaserId: purchaserId || '',
            orderNumber: orderNumber || (orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) || '',
            pageNumber: '1',
            pageSize: '10',
            invoiceType: 'ALL',
        },
    };
    useEffect(function () {
        if (openPTCDocumentDrawer) {
            GetBectranDocumentsAPI(ptcInvoicesRequest)
                .then(function (response) {
                setBectranInvoicesData(response.data);
            })
                .catch(function (error) {
                setBectranInvoicesError(error);
            })
                .finally(function () {
                setBectranInvoicesLoaded(true);
            });
        }
    }, [openPTCDocumentDrawer]);
    var isPTCTenderType = (tenders === null || tenders === void 0 ? void 0 : tenders.some(function (tender) { return ['PTC', 'HA'].includes(tender.type); })) || false;
    /**
     * Condition to render the PTCDocumentsLink component.
     */
    // If the feature switch for PTC Bectran is off, or if the payment type is not PTC or HA,
    // and the app is a consumer app, do not render the component.
    if (!FeatureSwitches.ptcBectran || !isPTCTenderType || isConsumerApp) {
        return null;
    }
    // Render the PTCDocumentsLink component
    // This component provides a link to view Pro Trade Credit Documents in a drawer.
    return (React.createElement(ErrorBoundary, { name: "PTCDocumentsLinkDrawer" },
        React.createElement(Link, { component: "button", onClick: function () { return setOpenPTCDocumentDrawer(true); } }, "View Pro Trade Credit Documents"),
        React.createElement(React.Fragment, { key: "right" },
            React.createElement(Drawer, { open: openPTCDocumentDrawer, onClose: handleCloseDrawer, position: "right" },
                React.createElement(PTCDocumentDrawerHeader, null),
                React.createElement(PTCDocumentDrawerBody, { invoiceResponse: (bectranInvoicesData === null || bectranInvoicesData === void 0 ? void 0 : bectranInvoicesData.invoiceResponse) || {}, bectranInvoicesError: bectranInvoicesError !== undefined, bectranInvoicesLoaded: bectranInvoicesLoaded }),
                React.createElement(PTCDocumentDrawerFooter, null)))));
};
